enum DiagramType {
	"mermaid" = "Mermaid",
	"plant-uml" = "Plant-uml",
	"c4-diagram" = "C4-diagram",
	"ts-diagram" = "Ts-diagram",
}

export default DiagramType;
